import Button from "@components/common/Button";
import { Modal } from "flowbite-react";
import { useState } from "react";
import { customModalTheme } from "styles/customTheme";
import ModalAlert from "./ModalAlert";

export const ModalConfirmationTopUp = ({
	isOpen,
	closeModal,
	onConfirm,
	setTopUpDirectly = false,
}) => {
	const [showSuccessModal, setShowSuccessModal] = useState(false);
	const [showErrorModal, setShowErrorModal] = useState(false);

	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const [errors, setErrors] = useState({});

	const handleSubmit = async () => {
		onConfirm();
	};

	return (
		<>
			<Modal show={isOpen} onClose={closeModal} size="4xl" theme={customModalTheme}>
				<Modal.Header className="border-none bg-gray-900" />
				<Modal.Body className="custom-scrollbar border-border_bottom">
					<div className="space-y-6">
						<div className="flex items-center justify-center">
							<div className="text-center">
								<p>
									By confirming this action, an additional 50 GB will be added to your authorized
									data and will be billed immediately.
								</p>
								<p className="pt-2 font-medium text-blue-500 text-sm text-warning">
									{setTopUpDirectly
										? "The top-up will be applied directly after clicking “Yes”. No further action is needed."
										: "Please make sure to save the config."}
								</p>
							</div>
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer className="flex justify-center border-t border-none">
					<Button
						text={loadingSubmit ? "Loading..." : "Yes"}
						onClick={() => handleSubmit()}
						className="!px-6 !py-2.5 !text-sm !min-w-[80px] bg-button-bg text-white hover:bg-button-hover"
						disabled={loadingSubmit}
					/>
					<Button
						text={"No"}
						color="gray"
						onClick={closeModal}
						className="!px-6 !py-2.5 !text-sm !min-w-[80px] bg-button-bg text-white hover:bg-button-cancel-hover hover:text-dark-blue"
					/>
				</Modal.Footer>
			</Modal>
			<ModalAlert
				isOpen={showErrorModal}
				type="error"
				closeModal={() => setShowErrorModal(false)}
				timeout={1000}
			/>
			<ModalAlert
				isOpen={showSuccessModal}
				type="success"
				closeModal={() => setShowSuccessModal(false)}
				message="Configuration created successfully"
				timeout={1000}
			/>
		</>
	);
};
